import { render, staticRenderFns } from "./Rendicion.vue?vue&type=template&id=09ddaa92&"
import script from "./Rendicion.vue?vue&type=script&lang=js&"
export * from "./Rendicion.vue?vue&type=script&lang=js&"
import style0 from "./Rendicion.vue?vue&type=style&index=0&id=09ddaa92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports